<template>
    <div class="vm-download-list">
        <a class="download-item flex-box black-8 gl-hover-text flex-align-items-baseline"
            v-for="(item, i) in list"
            :key="i"
            @click="jump_download"
            :href="!session_user ? false : item.download"
            target="_blank"
            >
                <i class="afd afd-download mr8 fs12"></i>
                <div class="fs12 flex-box flex-align-items-center " style="word-break: break-all;">
                <span class="text-overflow-1 flex-item-1">{{ item.title }}</span>
                <span class="black-3">（{{ $file_size(item.size) }}）</span>
            </div>
        </a>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'download-list',
    props: {
        list: {
            default(){
                return []
            }
        }
    },
    data() {
        return {
        };
    },
    computed:{
        ...mapState('app', [
            'session_user',
            'browser_size',
        ]),
    },
    mounted() {
    },
    methods: {
        jump_download() {
            if (!this.session_user) {
                this.$store.commit('app/set:redirect_url', this.$route.fullPath);
                this.$mixin_router_push('/login');
                return false;
            }
            return false;
            if (!this.GL.ENV.is_android && this.browser_size == 'small') {
                this.$notify({
                title: '请用电脑访问爱发电下载',
                group: 'error',
                });
            }
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-download-list{
    box-sizing: border-box;
    .download-item{
        margin-bottom:8px;
        &:last-child{
            margin-bottom:0px;
        }
    }

}
</style>
